import { UNKNOWN, UserEvents } from 'shared/consts';
import { VisitUiType, VisitsFiltersState } from './types';

import moment from 'moment-timezone';
import { track } from '@hqo/web-tracking';

const VISITS_FILTERS_LS_KEY = 'visitsFilters';

export const loadFiltersFromStorage = (): VisitsFiltersState | null => {
  try {
    const stored = localStorage.getItem(VISITS_FILTERS_LS_KEY);
    if (!stored) {
      return null;
    }
    const parsed = JSON.parse(stored) as VisitsFiltersState;
    // Basic validation - ensure it has the expected structure
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      typeof parsed.search === 'string' &&
      Array.isArray(parsed.status) &&
      Array.isArray(parsed.companyUuids) &&
      Array.isArray(parsed.hostUuids)
    ) {
      // hostOptions/companyOptions were added later; default them to an empty array
      // when missing so older persisted payloads still load successfully.
      return {
        ...parsed,
        companyOptions: Array.isArray(parsed.companyOptions) ? parsed.companyOptions : [],
        hostOptions: Array.isArray(parsed.hostOptions) ? parsed.hostOptions : [],
      };
    }
    return null;
  } catch {
    return null;
  }
};

export const saveFiltersToStorage = (filters: VisitsFiltersState): void => {
  try {
    localStorage.setItem(VISITS_FILTERS_LS_KEY, JSON.stringify(filters));
  } catch {
    // Silently fail if localStorage is not available or quota exceeded
  }
};

export const clearFiltersFromStorage = (): void => {
  try {
    localStorage.removeItem(VISITS_FILTERS_LS_KEY);
  } catch {
    // Silently fail if localStorage is not available
  }
};

// Pinned state is derived from whether filters exist in localStorage
export const isFiltersPinned = (): boolean => {
  return loadFiltersFromStorage() !== null;
};

export const getCurrentBuildingDateTime = (type: VisitUiType): { before?: string; after?: string } => {
  const currentBuildingDateTimeInUTC = moment().utc().toISOString();

  if (type === VisitUiType.PAST) {
    return { before: currentBuildingDateTimeInUTC };
  }

  if (type === VisitUiType.UPCOMING) {
    return { after: currentBuildingDateTimeInUTC };
  }

  return {};
};

export const visitCanceled = (integrationName?: string): void => {
  track(UserEvents.VISIT_CANCELED, { type: 'action', service_provider: integrationName ?? UNKNOWN });
};
